import React, { FC, useCallback, useMemo, useState } from 'react';
import {
	HistoryFilter,
	HistoryInterface,
	PaginationMetaInterface,
	ServiceProviderInterface,
} from '../interfaces';
// import { useTranslation } from './translation.service';
import { useAuth0 } from '@auth0/auth0-react';

const apiUrl = process.env.REACT_APP_API_URL || '';
const serviceRootURL = `${apiUrl}/api/history`;
const headers = {
	Authorization: '',
};

interface HistoryServiceInterface {
	meta: PaginationMetaInterface;
	historyItems: HistoryInterface[];
	getHistory: (filter?: HistoryFilter) => Promise<void>;
}

interface HistoryProviderInterface extends ServiceProviderInterface {}

const { createContext, useContext } = React;
const HistoryContext = createContext<HistoryServiceInterface>(
	{} as HistoryServiceInterface
);

export const HistoryProvider: FC<HistoryProviderInterface> = (props) => {
	const { getIdTokenClaims } = useAuth0();

	// const { t } = useTranslation();
	const [historyItems, setHistoryItems] = useState<HistoryInterface[]>([]);
	const [meta, setMeta] = useState<PaginationMetaInterface>(
		{} as PaginationMetaInterface
	);
	const getHistory = useCallback(
		async (filter?: HistoryFilter) => {
			const user = await getIdTokenClaims();
			headers.Authorization = user?.__raw || '';

			const res = await getHistoryApiCall(filter);
			if (res) {
				setHistoryItems(res.items);
				setMeta(res.meta);
			}
		},
		[setHistoryItems, getIdTokenClaims]
	);

	const value = useMemo(
		() => ({
			meta,
			historyItems,
			getHistory,
		}),
		[historyItems, meta]
	);

	return (
		<HistoryContext.Provider value={value}>{props.children}</HistoryContext.Provider>
	);
};

export const useHistoryService = () => {
	return useContext<HistoryServiceInterface>(HistoryContext);
};

const getHistoryApiCall = async (
	filter?: any
): Promise<{ items: HistoryInterface[]; meta: PaginationMetaInterface }> => {
	const params = new URLSearchParams(filter).toString();
	const res = await window.fetch(`${serviceRootURL}?${params}`, { headers });
	return res.json();
};
